/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Offer} from './Offer';

/**
 * The ProductShowOffersJson model module.
 * @module model/ProductShowOffersJson
 * @version v1
 */
export class ProductShowOffersJson {
  /**
   * Constructs a new <code>ProductShowOffersJson</code>.
   * @alias module:model/ProductShowOffersJson
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ProductShowOffersJson</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ProductShowOffersJson} obj Optional instance to populate.
   * @return {module:model/ProductShowOffersJson} The populated <code>ProductShowOffersJson</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ProductShowOffersJson();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('offers'))
        obj.offers = ApiClient.convertToType(data['offers'], [Offer]);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
ProductShowOffersJson.prototype.id = undefined;

/**
 * @member {String} image_url
 */
ProductShowOffersJson.prototype.image_url = undefined;

/**
 * @member {String} name
 */
ProductShowOffersJson.prototype.name = undefined;

/**
 * @member {Array.<module:model/Offer>} offers
 */
ProductShowOffersJson.prototype.offers = undefined;

